/**
 * Whether this page load is the infringement finder rather than PatentLoop.
 *
 * The finder ships in the same bundle as PatentLoop but is a separate site: on
 * infringement.patentloop.com (and the Amplify branch URL, which starts the same way) the
 * app renders only the finder, and on app.patentloop.com the finder has no route at all.
 *
 * For local development, where the host is localhost, set VITE_APP_MODE=infringement, or
 * open the dev server with ?app=infringement once — the choice is remembered for the tab.
 */
const SESSION_KEY = 'app_mode';

export function isInfringementHost(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.location.hostname.startsWith('infringement.')) return true;
  if (import.meta.env.VITE_APP_MODE === 'infringement') return true;
  try {
    const asked = new URLSearchParams(window.location.search).get('app');
    if (asked) sessionStorage.setItem(SESSION_KEY, asked);
    return sessionStorage.getItem(SESSION_KEY) === 'infringement';
  } catch {
    return false;
  }
}
